import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {CharityEffortsComponent} from './charity-efforts/charity-efforts.component';
import {PortersPageComponent} from './porters-page/porters-page.component';
import {PrivacyPolicyComponent} from './privacy-policy/privacy-policy.component';
import {RefundPageComponent} from './refund-page/refund-page.component';
import {TermsPageComponent} from './terms-page/terms-page.component';
import {TippingGuideComponent} from './tipping-guide/tipping-guide.component';
import {BookingAndRatesComponent} from './booking-and-rates/booking-and-rates.component';
import {GuidesPageComponent} from "./guides-page/guides-page.component";
import {ReviewsComponent} from "./reviews/reviews.component";

const routes: Routes = [
    {
        path: '',
        component: ContactUsComponent,
        data: {
            metaBlob: {
                title: 'Contact Us | Direct Access to a Kopa Tours Team Member',
                description: `Have questions about booking a Tanzania safari or Kilimanjaro trek? Contact Kopa Tours today by email, chat, or phone to talk to a dedicated team member!`,
                twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
                level: '1',
                index: '2'
            }
        }
    },
    {
        path: 'about-us',
        component: AboutUsComponent,
        data: {
            metaBlob: {
                title: 'About Us | Our Adventure of a Lifetime',
                description: `Learn why Kopa Tours is dedicated to sharing the natural treasures of Tanzania- where Mount Kilimanjaro looms over the wild plains of the Serengeti- with you.`,
                twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
                level: '1',
                index: '2'
            }
        }
    },
    {
        path: 'booking-and-rates',
        component: BookingAndRatesComponent,
        data: {
            metaBlob: {
                title: 'Booking and Rates | Cost Efficient Treks and Safari',
                description: `Use Kopa Tours' seamless online booking to find the perfect Kilimanjaro Hike or Serengeti Safari itinerary to fit your needs. Travel to Tanzania with Kopa Tours.`,
                twitterImage: '480x320/kilimanjaro-and-wildflowers-sm.jpg',
                level: '0',
                index: '0'
            }
        }
    },
    {
        path: 'charity-efforts',
        component: CharityEffortsComponent,
        data: {
            metaBlob: {
                title: 'Charity Efforts | Supporting the Community',
                description: `Kopa Tours is heavily invested in giving back to both the community and the environment in Tanzania. Donate to MKPS or plant a tree on Kili on your trip!`,
                twitterImage: 'others/tree-planting-project.jpg',
                level: '3',
                index: '2'
            }
        }
    },
    {
        path: 'porters-society',
        component: PortersPageComponent,
        data: {
            metaBlob: {
                title: 'Supporting the Mount Kilimanjaro Porters Society',
                description: `Mount Kilimanjaro porters are some of the hardest working people on the planet. Kopa Tours encourages working with the Mount Kilimanjaro Porters Society.`,
                twitterImage: 'others/porters-climbing-barranco-wall.jpg',
                level: '2',
                index: '7'
            }
        }
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        data: {
            metaBlob: {
                title: 'Privacy Policy | Kilimanjaro and Safari Adventures',
                description: `Kopa Tours will only collect information pertaining to the well-being and safety of our booked customers. We will never sell customer information.`,
                twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
                level: '0',
                index: '0'
            }
        }
    },
    {
        path: 'refund-policy',
        component: RefundPageComponent,
        data: {
            metaBlob: {
                title: 'Refund Policy | Kilimanjaro and Safari Adventures',
                description: `Kopa Tours offers a comprehensive refund policy to ensure our customers enjoy an easy, stress free booking process. Book early to take advantage if needed.`,
                twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
                level: '0',
                index: '0'
            }
        }
    },
    {
        path: 'terms-and-conditions',
        component: TermsPageComponent,
        data: {
            metaBlob: {
                title: 'Terms and Conditions',
                description: `Read our terms and conditions so you can feel comfortable booking with Kopa Tours. Travel to Tanzania with us today!`,
                twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
                level: '0',
                index: '0'
            }
        }
    },
    {
        path: 'tipping-guide',
        component: TippingGuideComponent,
        data: {
            metaBlob: {
                title: 'Tipping Guide | Kilimanjaro Guides and Safari Drivers',
                description: `One of the big stresses when traveling is tipping policy. This is why Kopa Tours offers a comprehensive tipping guide for porters, guides, cooks, and more.`,
                twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
                level: '2',
                index: '2'
            }
        }
    },
    {
      path: 'our-guides',
      component: GuidesPageComponent,
      data: {
        metaBlob: {
          title: 'Our Guides | Kilimanjaro Mountain Guides and Porters',
          description: `It takes a lot of effort to climb to the Roof of Africa. To do so safely and successfully, you climb a crew of 7 up the mountain. Meet all who help you get to the top.`,
          twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
          level: '2',
          index: '2'
        }
      }
    },
    {
      path: 'reviews',
      component: ReviewsComponent,
      data: {
        metaBlob: {
          title: 'Trip Reviews | Words from Kopa Tours Climbers',
          description: `Read reviews from travelers & adventurers who have climbed up Kilimanjaro with Kopa Tours`,
          twitterImage: 'kopa-branding/1x/Print%20Heart%20Badge_FINAL.png',
          level: '0',
          index: '0'
        }
      }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HelpfulInformationRoutingModule {
}
